export default __webpack_public_path__ + "static/media/logo.5e590d8b.png";